import React, { useState } from 'react';
import {
  ErrorMessage, Field, Form, Formik,
} from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import RegisterFormBottom from './RegisterFormBottom';
import toggleRegisterForm from '../../store/actions/registerFormToggle';
import ValidationSchema from '../../helpers/ValidationSchema';
import closeEyeIcon from '../../assets/icons/eyeClose.svg';
import openEyeIcon from '../../assets/icons/eyeOpen.svg';
import { loginRequest } from '../../store/actions/user';
import Spinner from '../Spinner';

function LoginForm() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { translations } = useSelector((state) => state.translation);
  const lang = Cookies.get('i18next') || 'en';
  const { signInSchema } = ValidationSchema();
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openPassword, setOpenPassword] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const localBasket = useSelector((state) => state.basketReducers.localBasket);
  const handleLogin = async (data) => {
    setLoading(true);
    const { payload } = await dispatch(loginRequest({ data, localBasket, lang }));
    if (payload.error) {
      setErrorMessage(payload.error);
    } else {
      setErrorMessage('');
      dispatch(toggleRegisterForm({ visible: false, type: 'login' }));
      window.location.replace(`/${lang}`);
      localStorage.removeItem('basket');
    }
    setLoading(false);
  };
  const handleOpenSignUp = () => {
    dispatch(toggleRegisterForm({ visible: true, type: 'register' }));
  };
  return (
    <Formik
      initialValues={{
        email: '',
        password: '',
      }}
      onSubmit={(values, actions) => {
        handleLogin({ ...values });
        actions.setSubmitting(false);
      }}
      validationSchema={signInSchema}
    >
      <Form className="register-form">
        <div className="register-form-group">
          <label className="inputs-label" htmlFor="email">{translations.email_label[lang]}</label>
          <div className="register-form-group_input input-block">
            <Field
              as="input"
              type="text"
              name="email"
              id="email"
              placeholder={translations.email_placeholder[lang]}
            />
          </div>
          <ErrorMessage
            name="email"
            component="p"
            className="authError"
          />
        </div>
        <div className="register-form-group">
          <label className="inputs-label" htmlFor="password">{translations.password_label[lang]}</label>
          <div className="register-form-group_input input-block ">
            <Field
              as="input"
              type={openPassword ? 'password' : 'text'}
              name="password"
              id="password"
              placeholder={translations.password_placeholder[lang]}
            />
            <button className="password-eye" type="button" onClick={() => setOpenPassword(!openPassword)}>
              <img
                src={openPassword ? closeEyeIcon : openEyeIcon}
                alt="eye"
              />
            </button>
          </div>
          <ErrorMessage
            name="password"
            component="p"
            className="authError"
          />
        </div>
        <RegisterFormBottom
          type="login"
          uniqueId="rememberMe"
          checked={checked}
          setChecked={() => {
            setChecked(!checked);
          }}
        />
        {errorMessage ? <p className="authError">{errorMessage}</p> : null}
        <button type="submit" className="register-form-button">
          {
          loading ? <Spinner isBtn size={20} /> : <p>{t('Login')}</p>
        }
        </button>
        <div className="have-account">
          <p>{t('dont_you_have_account')}</p>
          <button onClick={handleOpenSignUp} type="button">{t('Sign Up')}</button>
        </div>
      </Form>
    </Formik>
  );
}

export default LoginForm;
